import Heading from "../../../shared/ui/Typography/Heading";
import Text from "../../../shared/ui/Typography/Text";

import { buildPreferencesSummaryRows } from "../lib/preferencesSummary";
import ClientPreferencesEditModal from "./ClientPreferencesEditModal";

// ClientPreferencesSection — buyer/both search criteria
// (CRM-CLIENT-CONTACTS-MATCHING-A1).
//
// Visible for buyer/both even without preferences. Seller-only → null.
// Parent owns editorOpen + preferencesRevision coordination.

export { buildPreferencesSummaryRows };

function ClientPreferencesSection({
  client,
  canEdit = true,
  editorOpen = false,
  onRequestEditPreferences,
  onCloseEditor,
  onPreferencesSaved,
}) {
  if (!client) return null;

  const type = client.type;
  if (type !== "buyer" && type !== "both") return null;

  const prefs = client.preferences || null;
  const rows = buildPreferencesSummaryRows(prefs);
  const hasPrefs = Boolean(prefs) && rows.length > 0;

  return (
    <section
      className="cd-section feature-client-detail__section--preferences"
      aria-labelledby="client-detail-preferences-heading"
    >
      <header className="cd-section__head">
        <Heading
          id="client-detail-preferences-heading"
          level={2}
          variant="section"
          icon="fa-solid fa-magnifying-glass"
        >
          Що шукає
        </Heading>
        <div className="feature-client-detail__section-actions">
          {canEdit && hasPrefs ? (
            <button
              type="button"
              className="cd-add-btn"
              onClick={() => {
                if (typeof onRequestEditPreferences === "function") {
                  onRequestEditPreferences();
                }
              }}
            >
              Редагувати критерії
            </button>
          ) : null}
        </div>
      </header>

      {!hasPrefs ? (
        <div className="feature-client-detail__prefs-empty">
          <Text as="p" size="sm" tone="secondary">
            Критерії пошуку ще не налаштовані. Після збереження критеріїв
            система зможе підібрати відповідні об&apos;єкти.
          </Text>
          {canEdit ? (
            <button
              type="button"
              className="feature-client-detail__action-btn"
              onClick={() => {
                if (typeof onRequestEditPreferences === "function") {
                  onRequestEditPreferences();
                }
              }}
            >
              Налаштувати критерії
            </button>
          ) : null}
        </div>
      ) : (
        <dl className="feature-client-detail__prefs-grid">
          {rows.map((row) => (
            <div
              key={row.label}
              className="feature-client-detail__pref-row"
            >
              <dt className="feature-client-detail__pref-label">{row.label}</dt>
              <dd className="feature-client-detail__pref-value">{row.value}</dd>
            </div>
          ))}
        </dl>
      )}

      {canEdit ? (
        <ClientPreferencesEditModal
          open={editorOpen}
          onClose={() => {
            if (typeof onCloseEditor === "function") {
              onCloseEditor();
            }
          }}
          clientId={client.id}
          preferences={prefs}
          onSaved={(saved) => {
            if (typeof onPreferencesSaved === "function") {
              onPreferencesSaved(saved);
            }
          }}
        />
      ) : null}
    </section>
  );
}

export default ClientPreferencesSection;
